import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-800 text-white">
      <div className="container mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <p className="text-lg font-bold">数智洞察</p>
            <p className="text-sm text-gray-400">{t('footer.copyright')}</p>
          </div>
          <div className="flex space-x-6">
            <Link to="/privacy" className="text-gray-400 hover:text-white">{t('footer.privacy')}</Link>
            <Link to="/terms" className="text-gray-400 hover:text-white">{t('footer.terms')}</Link>
            <Link to="/contact" className="text-gray-400 hover:text-white">{t('header.contact')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
